<template>
  <div>
    <span>{{displayValues}}</span>
  </div>
</template>

<script>
export default {
  name: "RateValueDetailRow.vue",
  props: {
    existingRateValue: {type: Object, required: true},
    updatedRateValue: {type: Object, required: false}
  },
  data() {
    return {
      alwaysFilterProperties: ['RateValueId', 'RateYearId', 'CreatedBy', 'CreatedDate']
    }
  },
  computed: {
    ...amfx.map('cobraPlans', 'getCoverageLevel,getRateType'),
    ...amfx.map('cobraRates', 'individualTypes'),
    displayValues() {
      if (!this.updatedRateValue) return this.displayValuesWithoutChanges();

      return this.displayValuesWithChanges();
    },
  },
  methods: {
    displayValuesWithoutChanges() {
      const detailString = Object.entries(this.existingRateValue)
        .filter(([key, val]) => val != null && !this.alwaysFilterProperties.includes(key))
        .map(([key, value]) => `${this.formatKey(key)}=${this.formatValue(key, value)}`)
        .join(', ') + ` (id=${this.existingRateValue.RateValueId})`;

      return detailString;
    },
    displayValuesWithChanges() {
      const unchangedValues = [];
      const changedValues = [];

      Object.entries(this.existingRateValue).forEach(([key, existingVal]) => {
        if (this.alwaysFilterProperties.includes(key)) return;

        const updatedValue = this.updatedRateValue[key];

        if (!updatedValue && !existingVal) return;

        if (existingVal === updatedValue) {
          unchangedValues.push(`${this.formatKey(key)}=${this.formatValue(key, existingVal)}`);
          return;
        }
        changedValues.push(`${this.formatKey(key)}: ${this.formatValue(key, existingVal)} => ${this.formatValue(key, updatedValue)}`)
      });

      const unchangedValuesString = unchangedValues.join(', ');
      const changedValuesString = changedValues.join(', ');
      return `${unchangedValuesString}${unchangedValues.length > 0 ? ': ' : ''}${changedValuesString} (id=${this.existingRateValue.RateValueId})`;
    },
    formatKey(key) {
      return _.startCase(key);
    },
    formatValue(key, value) {

      if (!value) return 'none';

      if (typeof value === 'number') return value;

      if (key.toLowerCase().includes('date')) return formatters.date(value);

      if (key === 'CoverageLevel') return this.getCoverageLevel(value).name;

      if (key === 'IndividualType') return this.individualTypes.find(x => x.id === value).name;

      return value;
    }
  }
}
</script>

<style scoped lang="scss">
label {
  font-weight: bold;
  margin: 0;
}
strong {
  font-weight: bold;
}
flex {
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/history/modals/RateValueDetailRow.vue